import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { Column, GridOption, AngularGridInstance, Formatters } from 'angular-slickgrid';
import { CustomInputEditor } from '../custom-inputEditor';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-email-ticket',
    templateUrl: './email-ticket.component.html',
    styleUrls: ['./email-ticket.component.css']
})
export class EmailTicketComponent implements OnInit {

    masterNameSelected: number;
    masterName: string;
    description: string;
    clients: any[];
    clientId: number;

    senderTypeObj = [];
    senderTypeObj1 = [];
    selectedType: number;
    selectedTypeValue: number;
    selectedTypeValue1: number;

    respObjectSenderType: any;
    senderValue: string;
    domain: string;
    email: string;
    selectedTypeId: number;
    selectedTypeId1: number;
    respObjectSenderValue: any;

    displayData: any;
    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    masterNameObj = [];
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    add = false;
    del = false;
    edit = false;
    view = false;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;

    columnNameSelected: number;
    columnNameObj = [];
    validationValues: string;
    ticketSelected: number;

    ttypes = [];
    ticketTypeId: number;
    ticketType: string;
    ticketTypeSeq: number;
    ticketTypes = [];

    categoryLoaded: boolean;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    users = [];
    userSelected: number;
    keywordVal: String;
    busi_priority_id: number;
    userGroupId: number;
    respObjectSave: any;
    serviceUserName: String;
    serviceUserMail: any;
    serviceUserMobile: any;

    fullKeyword: String;
    ticketTypeEnum: String;
    dataLoaded: boolean;
    selectedIndextab: number;
    tabSelected: string;
    isFeedback: boolean;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {

                            if (item.sender_type === 0) {
                                if (item.sender !== '') {
                                    this.notifier.notify('error', "Domain / Email field should be empty for this sender type.");
                                    return;
                                }
                            }
                            else if (item.sender_type === 1) {
                                if (item.sender === "") {
                                    this.notifier.notify('error', "Email can not be empty");
                                    return;
                                } else if (!this.validateEmail(item.sender)) {
                                    this.notifier.notify('error', "Enter a valid email Id.");
                                    return;
                                }
                            }
                            // else if(item.sender_type === 2){
                            if (item.domain === '') {
                                this.notifier.notify('error', "Domain can not be empty");
                                return;
                            }
                            // }

                            if (item.keyword === '') {
                                this.notifier.notify('error', "Keyword can not be empty.");
                                return;
                            }

                            item.createdBy = this.messageService.getUserId();
                            item.client_id = this.clientId;
                            this._rest.editEmailTicketKeyword(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteEmailTicketKeyword({ id: item.id, user_id: this.messageService.getUserId() }).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;

        this.ticketSelected = 0;
        this.selectedIndextab = -1;
        this.selectedType = 0;
        this.senderValue = "";
        this.domain = "";
        this.email = "";
        this.selectedTypeId = 0;
        this.selectedTypeId1 = 0;
        this.isFeedback = false;

        this.keywordVal = "";

        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Email Based Ticket Config & Feedback config',
            openModalButton: 'Add Email Based Ticket Config & Feedback config',
            breadcrumb: '',
            folderName: '',
            tabName: ''
        };

        // this.masterNameObj = [{id: 1, name: 'asset master1'}, {id: 2, name: 'asset master2'}, {id: 3, name: 'asset master3'}];
        // this.masterNameObj.unshift({id: 0, name: 'Select asset master name'});
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            // {
            //     id: 'sender_type_name', name: 'Sender Type', field: 'sender_type_name', sortable: true, filterable: true
            // },
            {
                id: 'sender', name: 'Email', field: 'sender', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'domain', name: 'Domain', field: 'domain', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'keyword', name: 'Subject Keyword', field: 'keyword', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'delimiter', name: 'Delimiter', field: 'delimiter', sortable: true, filterable: true
            },
            {
                id: 'ticket_type', name: 'Ticket Type', field: 'ticket_type', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Ticket Category', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'user', name: 'User Name', field: 'user', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        // this._rest.getEmailTicketSenderType(this.clientId).subscribe((res1) => {
        //     this.respObjectSenderType = res1;
        //     if (this.respObjectSenderType.success) {
        //        console.log(JSON.stringify(this.respObjectSenderType));
        //        this.selectedTypeValue = this.respObjectSenderType.details[0].type;
        //        this.selectedTypeId = this.respObjectSenderType.details[0].id;
        //        this.senderTypeObj = this.respObjectSenderType.details;
        //     } else {
        //         this.notifier.notify('error', this.respObjectSenderType.errorMessage);
        //     }
        // }, (err) => {
        //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
        // });

        this.senderTypeObj = [{ "id": 2, "type": 1, "type_text": "From Specific Email" }, { "id": 3, "type": 2, "type_text": "From Specific Domain" }]

        this.senderTypeObj1 = [{ "id": 3, "type": 2, "type_text": "From Specific Domain" }];

        this.selectedTypeValue = this.senderTypeObj[0].type;
        this.selectedTypeId = this.senderTypeObj[0].id;

        this.selectedTypeValue1 = this.senderTypeObj1[0].type;
        this.selectedTypeId1 = this.senderTypeObj1[0].id;









        this.ticketSelected = 0;
        this.userSelected = 0;
        this.senderValue = "";
        this.domain = "";
        this.email = "";
        this.keywordVal = "";
        this.ticketTypeEnum = "";


        this.getTableData();
        this.getTicketType();
        this.getServiceUser();
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.masterNameSelected = 0;
            this.masterName = '';
            this.description = '';
            this.errorMessage = '';
            this.columnNameObj = [];
            this.columnNameSelected = 0;
            this.userSelected = 0;
            this.busi_priority_id = 0;
            this.userGroupId = 0;
            this.keywordVal = '';
            this.senderValue = "";
            this.domain = "";
            this.email = "";
            this.serviceUserName = "";
            this.serviceUserMail = "";
            this.serviceUserMobile = "";
            this.selectedTypeValue = this.senderTypeObj[0].type;
            this.selectedTypeId = this.senderTypeObj[0].id;

            this.selectedTypeValue1 = this.senderTypeObj1[0].type;
            this.selectedTypeId1 = this.senderTypeObj1[0].id;


            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getTicketType() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({ id: 0, name: 'Select Ticket Type' });
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    getServiceUser() {
        this._rest.getEmailTicketServiceUser(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, name: 'Select User' });
                this.users = this.respObject.details;
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR); 
        });
    }

    onServiceUserChange(selectedIndex: any) {
        // console.log(selectedIndex);

        this.userGroupId = this.users[selectedIndex].userGroupId;
        this.serviceUserName = this.users[selectedIndex].login_name;
        this.serviceUserMail = this.users[selectedIndex].mail;
        this.serviceUserMobile = this.users[selectedIndex].mobileno;


        console.log("...." + this.userGroupId + " " + this.serviceUserName + " " + this.serviceUserMail + " " + this.serviceUserMobile)
    }

    onChnageSenderType() {
        // console.log("okkkkkkkkkk"+ this.selectedIndextab);
        for (const i in this.senderTypeObj) {
            if (this.senderTypeObj[i].type == this.selectedTypeValue) {
                this.selectedTypeId = this.senderTypeObj[i].id;
                break;
            }
        }
    }
    onChnageSenderType1() {
        // console.log("okkkkkkkkkk"+ this.selectedIndextab);

        for (const i in this.senderTypeObj) {
            if (this.senderTypeObj1[i].type == this.selectedTypeValue1) {
                this.selectedTypeId1 = this.senderTypeObj1[i].id;
                break;
            }
        }
    }

    tabClick(event) {
        // console.log("........."+event.tab.textLabel)
        this.tabSelected = "" + event.tab.textLabel;
        if (this.tabSelected === "Add Email Base Feedback Config") {
            this.isFeedback = true;
        } else {
            this.isFeedback = false;

        }
    }

    onTicketChange(selectedIndex: any) {
        console.log(selectedIndex);
        this.ticketTypeId = this.ttypes[selectedIndex].id;
        this.ticketType = this.ttypes[selectedIndex].name;
        this.ticketTypeSeq = this.ttypes[selectedIndex].seq;

        if (this.ticketType === 'Incident') {
            this.ticketTypeEnum = 'IM';
        } else if (this.ticketType === 'Service Request') {
            this.ticketTypeEnum = 'SR';
        } else if (this.ticketType === 'Problem') {
            this.ticketTypeEnum = 'PR';
        }
        // else if(this.ticketType === ''){
        //     this.ticketTypeEnum = 'CR';
        // }


        // this.priority = '';
        // this.priorityId = 0;
        this._rest.getEmailTicketCreateLoadingDtls(this.messageService.getUserId(), this.ticketTypeId, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.categoryLoaded = true;
            if (this.respObject.success) {
                // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                //this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.ticketTypes = this.respObject.details[0].attribute;
                this.priorityType = this.respObject.details[0].val.type;
                //this.cat = [];
                // this.clientId = this.respObject.details[0].clientId;
                this.respObject.details[0].val.urgency.unshift({
                    id: 0,
                    name: 'Select Urgency'
                });
                this.respObject.details[0].val.impact.unshift({
                    id: 0,
                    name: 'Select Bussiness Impact'
                });
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

        // this._rest.getEmailTicketBusinessPriorityTicketTypeWise( this.clientId, this.ticketTypeId).subscribe((res) => {
        //     this.respObject = res;
        //     if (this.respObject.success) {
        //         console.log(this.respObject.details);
        //         this.busi_priority_id = this.respObject.details[0].id;
        //     } else {
        //         this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        // }, (err) => {
        //   this.notifier.notify('error', JSON.stringify(err));
        // });
    }

    onCategoryChange(ticket, option) {
        //  console.log('+++++++++++++++++++++', JSON.stringify(ticket), typeof option, ticket.id);
        const opt = JSON.parse(option);
        // console.log('++++++++++++++' + JSON.stringify(opt));
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //     this.attachment = [];
            // }
            const value = opt.id;
            const catVal = opt.title;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // console.log('index:' + index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.ticketTypes[index1].options[0].id;
            // console.log(this.ticketTypes[index1].options[0]);
            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value, catName: catVal });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        this.cat[i].catName = catVal;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value, catName: catVal });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // console.log('matched');
                        // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // clear sub categories
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }

            let cats = '';
            // let categoryName = '';
            let isError = false;
            const assetIds = [];
            // console.log('cat===' + JSON.stringify(this.cat));
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    cats += this.cat[i].cid;
                    if (i !== this.cat.length - 1) {
                        cats += ',';
                    }
                    // if (categoryName === '') {
                    //     categoryName = this.cat[i].catName;
                    // } else {
                    //     categoryName += ' / ' + this.cat[i].catName;
                    // }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                } else {
                    isError = true;
                    break;
                }
            }

            // console.log(value);
            this._rest.getEmailTicketFieldsCatWise({
                clientId: this.clientId,
                catId: cats,
                ticketTypeId: this.ticketTypeId
            }).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // // console.log(JSON.stringify(this.respObject.details));
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        if (this.respObject.details[i].predifinedValue !== null) {
                            this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                            this.respObject.details[i].value = this.respObject.details[i].values[0];
                        } else {
                            this.respObject.details[i].value = '';
                        }
                    }
                    this.dynamicFields = this.respObject.details;
                } else {
                }
            }, (err) => {
            });

            this._rest.getEmailTicketAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketTypeId).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                let data;
                if (index > -1) {
                    data = this.ticketTypes[index].options[0];
                }
                if (this.respObject.success) {
                    if (this.respObject.details.val) {
                        // data = this.ticketTypes[index].options[0];
                        this.respObject.details.val.unshift(data);
                        this.ticketTypes[index].options = this.respObject.details.val;
                    }
                    if (this.respObject.details.priority) {
                        //this.priority = this.respObject.details.priority.name;
                        //this.priorityId = this.respObject.details.priority.id;
                        this.busi_priority_id = this.respObject.details.priority.id;
                        console.log("........." + this.busi_priority_id);
                    }
                } else {
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }



    save() {

        let cats = '';
        let categoryName = '';
        let createTicketCat = '';

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                cats += this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    cats += ',';
                }
                if (categoryName === '') {
                    categoryName = this.cat[i].catName;
                } else {
                    categoryName += ' / ' + this.cat[i].catName;
                }
                // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
            } else {
                //isError = true;
                break;
            }
        }

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                createTicketCat += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    createTicketCat += ',';
                }
            } else {
                //isError = true;
                break;
            }
        }

        let requesterInfo = this.serviceUserName + '-' + this.messageService.xorEncode(atob(this.serviceUserMail), this.messageService.SECRET_TOKEN) +
            '-' + this.messageService.xorEncode(atob(this.serviceUserMobile), this.messageService.SECRET_TOKEN);

        const data = {
            client_id: this.clientId,
            sender_value: this.senderValue,
            sender_type_id: this.selectedTypeId,
            sender_type: this.selectedTypeValue,
            ticket_type_seq: this.ticketTypeSeq,
            ticketTypeId: this.ticketTypeId, 
            categoryDtlsLt: createTicketCat,
            category_id: cats,
            priorityType: this.priorityType,
            keyword: this.keywordVal,
        };

       

        if (this.selectedTypeValue === 1) {
            data["service_user_id"] = this.userSelected;
            data["userGroupId"] = this.userSelected;
            data['requesterInfo'] = requesterInfo;
        }
        console.log('data before====' + JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            if ((data.sender_type === 2) || (this.validateEmail(data.sender_value))) {
                // data.keyword = this.ticketTypeEnum +' '+ data.keyword;
                data.keyword = data.keyword;
                data['busi_priority_id'] = this.busi_priority_id;

                this._rest.addEmailTicketKeyword(data).subscribe((res1) => {
                    this.respObjectSave = res1;
                    if (this.respObjectSave.success) {
                        this.onPageLoad();
                        alert("Added successfully");
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObjectSave.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = "Enter a valid email Id.";

            }

        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }


    }


    submit() {
        const data = {
            client_id: this.clientId,
            sender_value: "comment",
            domain: this.domain,
            keyword: this.keywordVal,


        }

        // console.log("dataaa" + JSON.stringify(data));

        if (!this.messageService.isBlankField(data)) {
            //    data.keyword = data.keyword;
            this._rest.insertEmailFeedback(data).subscribe((res1) => {
                // console.log('insert');
                this.respObjectSave = res1;
                if (this.respObjectSave.success) {
                    this.onPageLoad();
                    alert("Added successfully");
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObjectSave.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        }
        else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }


    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validateDomain(domain) {
        var re = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
        return domain.match(re);
    }


    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
        }
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.allEmailTicketKeyword(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    // onTypeChange() {
    //   const data = {
    //       client_id: this.clientId,
    //       type: this.selectedTypeValue
    //   };
    //     console.log(this.selectedTypeValue);
    //     this._rest.editEmailTicketSenderType(data).subscribe((res1) => {
    //       this.respObjectSenderType = res1;
    //       if (this.respObjectSenderType.success) {
    //         this.onPageLoad();
    //         alert("Updated successfully");
    //       } else {
    //           this.notifier.notify('error', this.respObjectSenderType.errorMessage);
    //       }
    //   }, (err) => {
    //       this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //   });
    // }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({ 'offset': this.nextOffset, 'paginationType': '' });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }


}
